<div [ngClass]="mode === 'form' ? 'form-group partner-form-group' : 'lead-form-field'">
  <label>{{ label }} <span *ngIf="required">*</span></label>
  <select [ngModel]="normalizedValue" (ngModelChange)="onChange($event)" [disabled]="disabled">
    <option [ngValue]="null">{{ placeholder }}</option>
    <option *ngFor="let option of renderedOptions" [ngValue]="option.id">{{ option.company_name }}</option>
  </select>
</div>
